import { useState, useRef } from "react";
import { Button } from "@/components/ui/button";
import { Mic, Square, Loader2 } from "lucide-react";
import { toast } from "sonner";

export function VoiceButton({ transcribe, onText, testId, label = "Inspreken" }) {
  const [recording, setRecording] = useState(false);
  const [busy, setBusy] = useState(false);
  const mediaRef = useRef(null);
  const chunksRef = useRef([]);

  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mr = new MediaRecorder(stream);
      chunksRef.current = [];
      mr.ondataavailable = (e) => e.data.size && chunksRef.current.push(e.data);
      mr.onstop = async () => {
        stream.getTracks().forEach((t) => t.stop());
        const blob = new Blob(chunksRef.current, { type: "audio/webm" });
        setBusy(true);
        try {
          const text = await transcribe(blob);
          if (text) onText(text);
          else toast.info("Geen spraak herkend");
        } catch (e) {
          toast.error("Transcriptie mislukt");
        } finally {
          setBusy(false);
        }
      };
      mediaRef.current = mr;
      mr.start();
      setRecording(true);
    } catch {
      toast.error("Microfoon niet beschikbaar of geweigerd");
    }
  };
  const stop = () => { mediaRef.current?.stop(); setRecording(false); };

  return (
    <Button type="button" variant={recording ? "destructive" : "outline"} size="sm"
      onClick={recording ? stop : start} disabled={busy} data-testid={testId}>
      {busy ? <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> : recording ? <Square className="h-4 w-4 mr-1.5" /> : <Mic className="h-4 w-4 mr-1.5" />}
      {busy ? "Verwerken…" : recording ? "Stop opname" : label}
    </Button>
  );
}
